module.exports = __webpack_public_path__ + "static/mvpsports2-b0a26f569907e0b07f2acf316135b213.jpg";